export interface IPassword {
  password: string;
  confirmPassword: string;
}

export class ChangePasswordProfileFormvalues {
  currentPassword: string = "";
  password: string = "";
  confirmPassword: string = "";
}